import { apiSlice } from "./apiSlice";
import { MapUser } from "../mappers/User";

// Common function to categorize users
const categorizeUsers = (responseData: any) => {
    const mapped: any = {
        pendingIso: [],
        pendingNida: [],
        pendingUser: [],
        active: [],
        inactive: [],
        rejected: []
    };

    responseData.forEach((beUser: any) => {
        const user = MapUser(beUser);

        switch (user.ducStatus) {
        case "Expired":
            mapped.inactive.push(user);
            break;
        case "Declined":
            mapped.rejected.push(user);
            break;
        case "TrainingComplete":
            if(user?.signingUrl === "Pending ISO approval"){
                mapped.pendingIso.push(user);
            }else if(user?.signingUrl === "Pending NIDA approval"){
                mapped.pendingNida.push(user);
            }else {
                mapped.active.push(user);
            }
            break;
        case "Revoked":
            mapped.rejected.push(user);
            break;
        default:
            if(user?.signingUrl === "Pending ISO approval"){
                mapped.pendingIso.push(user);
            }
            else if (user?.signingUrl === "Pending NIDA approval"){
                mapped.pendingNida.push(user);
            }
            else{
                mapped.pendingUser.push(user)
            }
            break;
        }
    });

    return mapped;
};
export const userApiSlice = apiSlice.injectEndpoints({
    endpoints: builder => ({

        //TODO  All calls here are reactive and should be handled as stream baseStreamQuery.
        //TODO  Endpoints added as list of what we currently support on the back end.

        userInfo: builder.query({
            query: () => 'public/users/user_info',
            transformResponse: (responseData: any) => {
                return MapUser(responseData);
            }
        }),

        getUser: builder.query({
            query: ({ username }) => `/admin/users/username/${username}`,
            transformResponse: (responseData: any) => {
                return MapUser(responseData);
            }
        }),

        revokeUser: builder.mutation({
            query: ({ username }) => ({
                url: `/admin/users/revoke/${username}`,
                method: 'POST',
            }),
            transformResponse: (responseData: any) => MapUser(responseData),
            invalidatesTags: ['All_Users']
        }),

        searchUsername: builder.query({
            query: ({ username }) => `/admin/users/search/username/${username}`,
            transformResponse: (responseData: any) => categorizeUsers(responseData)
        }),

        searchEmail: builder.query({
            query: ({ email }) => `/admin/users/search/email/${email}`,
            transformResponse: (responseData: any) => categorizeUsers(responseData)
        }),

        searchFirstName: builder.query({
            query: ({ firstName }) => `/admin/users/search/first-name/${firstName}`,
            transformResponse: (responseData: any) => categorizeUsers(responseData)
        }),

        searchLastName: builder.query({
            query: ({ lastName }) => `/admin/users/search/last-name/${lastName}`,
            transformResponse: (responseData: any) => categorizeUsers(responseData)
        }),

        getAll: builder.query({
            query: () => '/admin/users',
            providesTags: ['All_Users'],
            transformResponse: (responseData: any) => categorizeUsers(responseData)
        }),
        getAllByDucType: builder.query({
            query: ({ ducType }) => `/admin/users/ducType/${ducType}`,
            providesTags: ['All_Users'],
            transformResponse: (responseData: any) => categorizeUsers(responseData)
        }),

        updateUser: builder.mutation({
            query: (updatedFields) => {
                return {
                    url: `/users/${updatedFields.username}`,
                    method: 'PATCH',
                    body:  updatedFields
                }
            },
            invalidatesTags: ['All_Users']
        }),

        getUrl: builder.query({
            query: ({ email }) => `/admin/url/email/${email}`
        }),

    })
});

export const {
    useUserInfoQuery,
    useGetAllQuery,
    useGetUserQuery,
    useRevokeUserMutation,
    useSearchUsernameQuery,
    useSearchEmailQuery,
    useSearchFirstNameQuery,
    useSearchLastNameQuery,
    useUpdateUserMutation,
    useGetUrlQuery,
    useGetAllByDucTypeQuery
} = userApiSlice;